import { jsx as m } from "react/jsx-runtime";
import { useState as i, useRef as d, useCallback as p, useEffect as N } from "react";
import { formatHumanReadableTimeLeft as S } from "../utils/timeFormat.js";
const w = (t) => {
  const r = Math.floor(t / 1e3 / 60 % 60).toString().padStart(2, "0"), e = Math.floor(t / 1e3 % 60).toString().padStart(2, "0");
  return `${r}:${e}`;
}, n = "countdown", C = (t) => t <= 0 ? `${n}--expired` : t <= $ ? `${n}--warning` : `${n}--normal`, $ = 1e4, l = 1e3;
function T({ endTimeInMs: t, format: r = "mm:ss", paused: e = !1 }) {
  const [o, c] = i(t - Date.now()), a = d(null), u = p(() => {
    a.current = setInterval(() => {
      if (t <= Date.now()) {
        c(0), s();
        return;
      }
      c((f) => f - l);
    }, l);
  }, [t]), s = () => {
    a.current && clearInterval(a.current);
  };
  return N(() => (e ? s() : u(), () => s()), [e, u]), /* @__PURE__ */ m(
    "span",
    {
      className: `${n} ${C(o)}`,
      "data-testid": "countdown-text",
      children: r === "mm:ss" ? w(o) : S(o)
    }
  );
}
export {
  l as COUNTDOWN_INTERVAL_TICK_MS,
  T as Countdown
};
//# sourceMappingURL=Countdown.js.map
